import React, { useState, useRef } from "react";
import { uploadFile } from "./upload_manager";
import { CircularProgress } from "@mui/material";
import VoiceMicButton from "../../components/VoiceMicButton";

export default function FileUploader({
    isMultiFile = false,
    commit = {
        repo_name: "Acm_Corp",
        username: "sujithvs",
        email: "sujithvs.think@gmail.com",
        commit_message: "Initial Commit",
        is_first_commit: true
    },
    back = () => { }
}) {

    const inputRef = useRef();
    const inputcommitRef = useRef();
    const checkboxRef = useRef();
    const commitIdRef = useRef();

    // drag counter fixes nested drag events
    const dragCounter = useRef(0);

    const [files, setFiles] = useState([]);
    const [error, setError] = useState();
    const [dragActive, setDragActive] = useState(false);
    const [loading, setLoading] = useState(false);

    // ---------------------------------------------------
    // HANDLE FILES
    // ---------------------------------------------------
    function handleFiles(fileList) {
        setError(undefined);
        const list = Array.from(fileList).map(file => ({
            file,
            progress: 0,
            speed: 0,
            remaining: 0
        }));

        setFiles(prev => {

            // single file mode
            if (!isMultiFile) {
                return list.slice(0, 1);
            }

            // append files in multi mode
            return [...prev, ...list];

        });

    }

    // ---------------------------------------------------
    // START UPLOAD
    // ---------------------------------------------------
    async function startUpload() {
        if (!inputcommitRef.current?.value || inputcommitRef.current.value.trim().length < 3) {
            setError({ status: "Please add a commit message (min 3 chars)", bg: '#ef4444', color: 'white' });
            return;
        }

        if (files.length === 0) {
            setError({ status: "Please select files to upload", bg: '#ef4444', color: 'white' });
            return;
        }

        setLoading(true);
        setError(undefined);

        for (let index = 0; index < files.length; index++) {
            const item = files[index];
            try {
                const res = await uploadFile(
                    item.file,
                    (data) => {
                        if (data.error) {
                            setLoading(false);
                            setError({ status: data?.message || "Upload error", bg: '#ef4444', color: 'white' });
                        }
                        if (data.success) {
                            setLoading(false);
                            setError({ status: "File Successfully uploaded", bg: '#10b981', color: 'white' });
                            setTimeout(() => {
                                back();
                            }, 1000);
                        }
                        setFiles(prev =>
                            prev.map((f, i) =>
                                i === index
                                    ? {
                                        ...f,
                                        progress: data.progress || 0,
                                        speed: typeof data.speed === 'number' ? (data.speed / 1024 / 1024).toFixed(2) : (data.speed || "0.00"),
                                        remaining: typeof data.remaining === 'number' ? data.remaining.toFixed(1) : (data.remaining || "0.0"),
                                        loading: data.loading || false
                                    }
                                    : f
                            )
                        );
                    },
                    {
                        filename: item.file.name,
                        ...commit,
                        commit_message: inputcommitRef.current.value,
                        is_first_commit: commit?.is_first_commit,
                        base_commit: commitIdRef.current?.value || commit?.base_commit || "",
                    }
                );

                if (typeof res === "string" && (res.toLowerCase().includes("already") || res.toLowerCase().includes("exist"))) {
                    setError({ status: "File already exists. No new changes detected.", bg: '#f59e0b', color: 'white' });
                    setLoading(false);
                    setTimeout(() => {
                        back();
                    }, 1800);
                } else if (res && (res.status === "no_change" || res.exists)) {
                    setError({ status: res.message || "File already exists with identical content. No changes detected.", bg: '#f59e0b', color: 'white' });
                    setLoading(false);
                    setTimeout(() => {
                        back();
                    }, 1800);
                } else if (typeof res === "string" && res.toLowerCase().includes("fail")) {
                    setError({ status: res, bg: '#ef4444', color: 'white' });
                    setLoading(false);
                } else if (res && (res.status === "upload_complete" || res.commit_id)) {
                    setError({ status: "File Successfully uploaded", bg: '#10b981', color: 'white' });
                    setLoading(false);
                    setTimeout(() => {
                        back();
                    }, 1000);
                }
            } catch (err) {
                console.error("Upload error:", err);
                setError({ status: err?.response?.data?.error || err?.message || "Upload failed", bg: '#ef4444', color: 'white' });
                setLoading(false);
            }
        }
        setLoading(false);
    }

    // ---------------------------------------------------
    // DRAG EVENTS
    // ---------------------------------------------------
    const dragEnterHandler = (e) => {

        e.preventDefault();
        e.stopPropagation();

        dragCounter.current++;

        if (e.dataTransfer.items?.length > 0) {
            setDragActive(true);
        }

    };

    const dragLeaveHandler = (e) => {

        e.preventDefault();
        e.stopPropagation();

        dragCounter.current--;

        if (dragCounter.current <= 0) {
            setDragActive(false);
        }

    };

    const dragOverHandler = (e) => {

        e.preventDefault();
        e.stopPropagation();

    };

    const dropHandler = (e) => {

        e.preventDefault();
        e.stopPropagation();

        setDragActive(false);
        dragCounter.current = 0;

        if (e.dataTransfer.files?.length > 0) {
            handleFiles(e.dataTransfer.files);
        }

    };

    return (

        <div style={styles.wrapper}>

            <h5>
                Upload Files to {commit.repo_name}
            </h5>

            {/* --------------------------------------------------- */}
            {/* DROP ZONE */}
            {/* --------------------------------------------------- */}
            <div
                style={{
                    ...styles.dropZone,
                    ...(dragActive ? styles.dropZoneActive : {})
                }}
                onDrop={dropHandler}
                onDragEnter={dragEnterHandler}
                onDragLeave={dragLeaveHandler}
                onDragOver={dragOverHandler}
                onClick={() => inputRef.current.click()}
            >

                <p style={styles.dropTitle}>
                    {dragActive
                        ? "Drop files here"
                        : "Drag & Drop files here"}
                </p>

                <p>or</p>

                <button
                    type="button"
                    style={styles.button}

                    Choose Files
                >Select File</button>

                <input
                    type="file"
                    multiple={isMultiFile}
                    ref={inputRef}
                    style={{ display: "none" }}
                    onChange={(e) => handleFiles(e.target.files)}
                />

            </div>

            {/* --------------------------------------------------- */}
            {/* COMMIT MESSAGE */}
            {/* --------------------------------------------------- */}
            <div style={{ position: 'relative' }}>
                <textarea
                    required
                    style={{ ...styles.textarea, paddingRight: 36 }}
                    placeholder="Commit Message"
                    ref={inputcommitRef}
                />
                <div style={{ position: 'absolute', right: 8, top: 12, zIndex: 5 }}>
                    <VoiceMicButton
                        initialText={inputcommitRef.current?.value || ''}
                        onTranscript={(text) => {
                            if (inputcommitRef.current) {
                                inputcommitRef.current.value = text;
                            }
                        }}
                        size={16}
                    />
                </div>
            </div>

            {/* --------------------------------------------------- */}
            {/* COMMIT ID */}
            {/* --------------------------------------------------- */}
            <input
                readOnly
                defaultValue={commit?.base_commit || ""}
                style={{ background: '#fff', border: 'none', padding: 0 }}
                // placeholder="Commit ID"
                ref={commitIdRef}
            />


            {/* --------------------------------------------------- */}
            {/* BUTTONS */}
            {/* --------------------------------------------------- */}
            <div style={styles.buttonGroup}>
                <button
                    style={{ ...styles.button, background: "#e88742ff", }}
                    onClick={back}
                > Back</button>

                <button
                    disabled={loading}
                    style={{ ...styles.button, opacity: loading ? 0.7 : 1, cursor: loading ? "not-allowed" : "pointer" }}
                    onClick={startUpload}
                >
                    <div style={{ display: 'flex', alignItems: "center", justifyContent: "center", gap: 8 }}>
                        {loading ? <CircularProgress size="18px" sx={{ color: "#ffffff" }} /> : null}
                        <span>{loading ? "Uploading..." : "Upload"}</span>
                    </div>
                </button>

            </div>

            {/* --------------------------------------------------- */}
            {/* ERROR / STATUS */}
            {/* --------------------------------------------------- */}
            {error && (
                <div style={{ ...styles.error, background: (error.bg || styles.error.background), color: (error.color || '#fff') }}>
                    {typeof error === 'object' && error?.status ? error.status : (typeof error === 'string' ? error : 'Upload status update')}
                </div>
            )}


            {/* --------------------------------------------------- */}
            {/* FILE LIST */}
            {/* --------------------------------------------------- */}
            <div style={{ marginTop: 20 }}>

                {files.map((u, i) => (

                    <div key={i} style={styles.fileBox}>

                        <div style={styles.fileName}>
                            {u.file.name}
                        </div>

                        <div style={styles.progressBar}>

                            <div
                                style={{
                                    ...styles.progress,
                                    width: `${u.progress}%`
                                }}
                            />

                        </div>

                        <div style={styles.meta}>

                            <span>
                                {u.progress}%
                            </span>

                            <span>
                                Speed: {u.speed} MB/s
                            </span>

                            <span>
                                Remaining: {u.remaining}s
                            </span>

                        </div>

                    </div>

                ))}

            </div>

        </div >

    );

}

const styles = {

    wrapper: {
        maxWidth: 600,
        margin: "40px auto",
        background: "#fff",
        padding: 30,
        borderRadius: 10,
        boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
        fontFamily: "Arial"
    },

    dropZone: {
        border: "2px dashed #4a90e2",
        borderRadius: 10,
        padding: 40,
        textAlign: "center",
        cursor: "pointer",
        background: "#f9fbff",
        transition: "all 0.2s ease"
    },

    dropZoneActive: {
        background: "#e8f2ff",
        border: "2px dashed #1976d2",
        transform: "scale(1.01)"
    },

    dropTitle: {
        fontSize: 18,
        margin: 0
    },

    button: {
        marginTop: 10,
        padding: "10px 20px",
        border: "none",
        background: "#4a90e2",
        color: "#fff",
        borderRadius: 6,
        cursor: "pointer"
    },

    buttonGroup: {
        display: "flex",
        gap: 10,
        marginTop: 10
    },

    textarea: {
        width: "100%",
        minHeight: 80,
        marginTop: 10,
        padding: 10,
        borderRadius: 6,
        border: "1px solid #ccc",
        resize: "vertical",
        boxSizing: "border-box"
    },

    input: {
        width: "100%",
        marginTop: 10,
        padding: 10,
        borderRadius: 6,
        border: "1px solid #ccc",
        boxSizing: "border-box"
    },

    checkboxWrapper: {
        display: "flex",
        alignItems: "center",
        gap: 10,
        marginTop: 10
    },

    fileBox: {
        marginTop: 20
    },

    fileName: {
        marginBottom: 6,
        wordBreak: "break-all"
    },

    progressBar: {
        width: "100%",
        height: 10,
        background: "#ddd",
        borderRadius: 5,
        overflow: "hidden"
    },

    progress: {
        height: "100%",
        background: "#4caf50",
        transition: "width 0.2s linear"
    },

    meta: {
        fontSize: 12,
        marginTop: 5,
        display: "flex",
        gap: 10,
        flexWrap: "wrap"
    },

    error: {
        color: "black",
        background: "#ff5d5d",
        padding: 8,
        borderRadius: 5,
        marginTop: 10
    }

};